import $ from "jquery";


// Takes an entire table and uses it's rows,
// OR takes a table and a specific set of rows
export function matchChildrenWidthsToParentCols({table, rows}){
  let childRows;
  if(rows){
    childRows = rows;
  }
  else{
    childRows = table.find('.child-table-row');
  }

  if(childRows.length){
    const parentColHeaders = table.find('> thead > tr > th');
    childRows.each(function(){
      const childCols = $(this).find('> td');
      matchChildColWidthsToParentCols(childCols, parentColHeaders);
    });
  }
}

function matchChildColWidthsToParentCols(childCols, parentColHeaders){
  parentColHeaders.each(function(i){
    const parentCol = $(this);
    const childCol = childCols.eq(i);
    const width = parentCol.width();
    childCol.css("width", width);
  });
}


// WEBPACK FOOTER //
// ./src/utilities/jqueryDataTableChildren/index.js